import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { RiderService } from '../../../riders/rider.service';
import { GridOptions } from 'ag-grid';
import { ViewAttachmentFileComponent } from '../../../A2-utils/grid-components/view-attachment-file/view-attachment-file.component';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { ResponseInterface } from '../../../../core/interfaces/response.interface';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';

@Component({
  selector: 'app-rider-history',
  templateUrl: './rider-history.component.html',
  styleUrls: ['./rider-history.component.scss']
})
export class RiderHistoryComponent implements OnInit, OnChanges {

  @Input() riderId: number;
  @Input() isDisableRider: boolean;
  @ViewChild('attachDocumentT2Card') attachDocumentT2Card: T2CardComponent;
  protected dataGrid = [];
  protected grid: GridOptions;

  protected description: string;
  protected file: any;
  protected base64textString: string;

 

  constructor(protected service: RiderService, private sweetAlertHelper: SweetAlertHelper, private _loadingT2: T2LoadingService) {
    this.grid = <GridOptions>{
      columnDefs: this.columDefs(),
      enableColResize: true,
      enableFilter: true,
      enableSorting: true,
    };
    this.grid.onGridReady = () => {
      this.grid.api.sizeColumnsToFit();
    };
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataGrid = [];
    if (changes['riderId'] && this.riderId != 0) {
      this.loadRiderHistory(this.riderId);
    }
  }

  private loadRiderHistory(riderId: number) {
    this._loadingT2.show('Loading Please wait...');
    this.service.getRiderHistory(riderId).subscribe(
      data => {
        this.dataGrid  = data;

          this._loadingT2.hiden()

      }
    );
  }

  

  private columDefs() {
    return [
      {
        headerName: 'Date',
        field: 'date',
        colId: 'date',
        width: 90
      },
      {
        headerName: 'Time',
        field: 'time',
        colId: 'time',
        width: 100
      },
      {
        headerName: 'Description',
        field: 'description',
        colId: 'description',
        width: 350
      },
      {
        headerName: 'User',
        field: 'user',
        colId: 'user',
        width: 160
      },
      {
        headerName: 'Type',
        field: 'type',
        colId: 'type',
        width: 100
      },
      {
        headerName: 'File',
        field: 'attachfile',
        cellRendererFramework: ViewAttachmentFileComponent,
        colId: 'attachedFile',
        width: 50
      }
    ];
  }

  onAttachDocument($event: any) {
    const files = $event.target.files;
    const file = files[0];
    this.file = file;
    if (files && file) {
      const reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
  }

  saveAttachment() {
    if (this.riderId && this.base64textString && this.file && this.description) {
      const data = {
        riderid: this.riderId,
        attachement: this.base64textString,
        mimetype: this.file.type,
        attachementname: this.description
      };

      this.service.addHistoryFile(data).subscribe(
        (resp: ResponseInterface) => {
          this.resetDate();
          this.loadRiderHistory(this.riderId);
          this.swal('success', resp)
        }, (error: ResponseInterface) => this.swal('error', error)
      );
    } else {
      this.swal('warning', null, 'Select File');
    }
  }

  private resetDate() {
    this.base64textString = undefined;
    this.file = undefined;
    this.description = undefined;
  }

  private swal(type: any, resp?: ResponseInterface, msj?: string) {
    this.sweetAlertHelper.createCustomAlert({
      position: 'top-end',
      type: type,
      title: msj ? msj : resp.message,
      showConfirmButton: false,
      timer: 2500
    });
  }

  emitterActionT2Card($event: any) {
    !$event.isOpen ? this.resetDate() : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-history/rider-history.component.ts